import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { handleAxiosError } from 'src/utils/errorHandling'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import { sendingRequestToJoinBottle } from '../utils/sendingRequestToJoinBottle'

export const useJoinToBottle = (entrySum: number | undefined = 0, type: string | undefined = 'ANY') => {
  const reducingBalanceStars = useGlobalStore((store) => store.reducingBalanceStars)

  const navigate = useNavigate()
  const location = useLocation()
  const { id: bottleId } = useParams()

  const joinToBottle = async () => {
    try {
      await sendingRequestToJoinBottle(Number(bottleId), 'STARS', entrySum)
      reducingBalanceStars(entrySum || 0)

      if (type !== 'FIXED') {
        navigate(`/bottles/${bottleId}`, { state: { from: location.pathname } })
      }
    } catch (err) {
      navigate('/bottles/join-error')
      const errorMessage = handleAxiosError(err)
      console.log(errorMessage)
    }
  }

  return { joinToBottle }
}
